import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';
import './industries.css'

import img1 from "../../assets/images/industries/retail-ecommerce.png";
import img2 from "../../assets/images/industries/education-e-learning.png";
import img3 from "../../assets/images/industries/healthcare-fitness.png";
import img4 from "../../assets/images/industries/logistics-distribution.png";
import img5 from "../../assets/images/industries/social-networking.png";
import img6 from "../../assets/images/industries/real-estate.png";
import img7 from "../../assets/images/industries/travel-hospitality.png";
import img8 from "../../assets/images/industries/food-restaurant.png";
import img9 from "../../assets/images/industries/on-demand-solutions.png";
import img10 from "../../assets/images/industries/gaming.png";
import img11 from "../../assets/images/industries/healthcare.png";
import img12 from "../../assets/images/industries/product-manufacturer-img.png";
import img13 from "../../assets/images/industries/doctor.png";
import img14 from "../../assets/images/industries/bfsi-solution.png";

import SEO from '../seo';

const industries = [
    { img: img14, name: "BFSI Solutions", route: '/industries/bfsi-solution' },
    { img: img13, name: "Doctors", route: '/industries/doctors' },
    { img: img2, name: "Education & E-learning", route: '/industries/education' },
    { img: img8, name: "Food & Restaurant", route: '#' },
    { img: img10, name: "Gaming", route: '/industries/sports-gaming' },
    { img: img11, name: "Healthcare", route: '/industries/healthcare' },
    { img: img3, name: "Healthcare & Fitness", route: '/industries/healthcare' },
    { img: img4, name: "Logistics & Distribution", route: '/industries/logistics' },
    { img: img9, name: "On-Demand Solutions", route: '#' },
    { img: img12, name: "Product Manufacturer", route: '/industries/product-manufacturer' },
    { img: img6, name: "Real Estate", route: '/industries/real-estate' },
    { img: img1, name: "Retail & E-commerce", route: '/industries/e-commerce' },
    { img: img5, name: "Social Networking", route: '#' },
    { img: img7, name: "Travel & Hospitality", route: '#' },
];

export default function Industry() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
            <SEO
                title="Industries"
                description="Industries We Serve Here, we make almost every genre of applications. You name it and we build it. Retail, Ecommerce Education &#038; E-learning Healthcare &#038; Fitness Logistics &#038; Distribution Social Networking Real Estate Travel &#038; Hospitality Food &#038; Restaurant On-Demand Solutions Gaming Healthcare Product Manufacturer Doctors BFSI Solutio"
                canonical="https://www.hwplindia.com/industries/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/retail-ecommerce.png"
                keywords={pageKeywords}
            />

            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Industries</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Industries</li>
                    </ul>
                </div>
            </section>
            <div className="parallax-content">
                <div className="indu-box">
                    <h1 className="mainindu-title">Industries We Serve</h1>
                    <p className='mainindu-p sec-sub-ma'>Here, we make almost every genre of applications. You name it and we build it.</p>
                    <div className="industries-grid">
                        {industries.map((item, index) => (
                            <div className="industry-item" key={index}>
                                <Link to={item.route}><img src={item.img} alt={item.name} /></Link>
                                <Link to={item.route}><p>{item.name}</p></Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}